import { CreateSupplyIntent } from "@/features/treasury/treasury";

export default function TreasuryLendingSupplyPage() {
  return <CreateSupplyIntent />;
}
